import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-8c1f1294"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "login lg"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "login-top"
}, "Reset your password", -1));

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "login-form-p"
}, "Password", -1));

const _hoisted_4 = {
  class: "lg-div"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconguanbi2fill hide"
}, null, -1));

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "login-form-p"
}, "Password Confirmation", -1));

const _hoisted_7 = {
  class: "lg-div"
};

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconguanbi2fill hide"
}, null, -1));

const _hoisted_9 = {
  class: "loginSuccess forget-email-success"
};

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Tips", -1));

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconyuanxingxuanzhongfill"
}, null, -1));

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "loginPTwo"
}, "The password was reset successfully and entered the login page in 3 seconds.", -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives(_createElementVNode("div", null, [_hoisted_2, _hoisted_3, _createElementVNode("div", _hoisted_4, [_withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.password = $event),
    type: "password",
    class: "lg-input",
    id: "username"
  }, null, 512), [[_vModelText, _ctx.password]]), _hoisted_5]), _hoisted_6, _createElementVNode("div", _hoisted_7, [_withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.confirmPassword = $event),
    type: "password",
    class: "lg-input",
    id: "username"
  }, null, 512), [[_vModelText, _ctx.confirmPassword]]), _hoisted_8]), _createElementVNode("button", {
    class: "login-btn",
    onClick: _cache[2] || (_cache[2] = //@ts-ignore
    (...args) => _ctx.retrievePasswordMailFn && _ctx.retrievePasswordMailFn(...args))
  }, "Update password")], 512), [[_vShow, !_ctx.isSuccess]]), _withDirectives(_createElementVNode("div", _hoisted_9, [_hoisted_10, _hoisted_11, _hoisted_12, _createElementVNode("button", {
    class: "login-btn",
    onClick: _cache[3] || (_cache[3] = //@ts-ignore
    (...args) => _ctx.toLogin && _ctx.toLogin(...args))
  }, "I got it!")], 512), [[_vShow, _ctx.isSuccess]])]);
}